import React, { useState } from 'react';
import { useController } from 'react-hook-form';

// components
import FormFieldLabel from '../FormFieldLabel';
import FormFieldError from '../FormFieldError';
import FormFieldDescription from '../FormFieldDescription';
import EyeIcon from '../../../../icons/EyeIcon';
import EyeSlashIcon from '../../../../icons/EyeSlashIcon';

const Password = ({ name, control, rules, label, description, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);
    
    const {
        field,
        fieldState: { error }
    } = useController({
        name,
        control,
        rules
    });

    const handleChange = (e) => {
        field.onChange(e.target.value);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const displayValue = field.value || '';

    return (
        <div className="FormField FormField--password">
            <FormFieldLabel label={label} name={name} rules={rules}/>
            <div className={`FormField__passwordInner ${showPassword ? 'showPassword' : 'hidePassword'}`}>
                <input
                    {...props}
                    id={name}
                    type={showPassword ? 'text' : 'password'}
                    value={displayValue}
                    onChange={handleChange}
                />
                <button
                    type="button"
                    className="FormField__passwordToggle"
                    onClick={togglePasswordVisibility}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                    {showPassword ? <EyeIcon /> : <EyeSlashIcon />}
                </button>
            </div>
            {error ? (
                <FormFieldError error={error} />
            ) : (
                <FormFieldDescription description={description} />
            )}
        </div>
    );
}

export default Password;